import { render } from "./ModalInformes.vue?vue&type=template&id=727ca61f"
import script from "./ModalInformes.vue?vue&type=script&lang=js"
export * from "./ModalInformes.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__